import React, { useCallback } from 'react';

import Button from 'components/form/Button.component';
import useTip from 'hooks/useTip.hook';
import logger from 'utils/logger.util';

const L = logger('OpenIntercomButton'); // eslint-disable-line no-unused-vars

const OpenIntercomButton = () => {
  const { val: isIntercomOpen, nay: hide, yay: show } = useTip(false);
  const toggleIntercom = useCallback(() => {
    if (!window.Intercom) {
      L.debug('()', 'Intercom is not available');
      return;
    }

    if (isIntercomOpen) {
      window.Intercom('hide');
      hide();
    } else {
      window.Intercom('show');
      show();
    }
  }, [hide, isIntercomOpen, show]);

  return (
    <Button variant="bin" onClick={toggleIntercom}>
      <span style={{ fontSize: '32px' }}>📞</span>
    </Button>
  );
};

export default OpenIntercomButton;
